export const data9_8_2_default = [
   {
      name: "茶包",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "茶包",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "速溶咖啡包",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "员工用油",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "客用油",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "客用米",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "员工米",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "矿泉水",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "牛奶",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "早餐肠",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "培根",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "谷物",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }, {
      name: "果汁（自助餐）",
      type: "",
      brand: "",
      size: "",
      unit: "",
      price: 0,
      annual: "",
      aMonth: ""
   }
];


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-8/9-8-3/data.js